export default __webpack_public_path__ + "assets/logos/project44-small-logo.cda599c29a5fb33f84aba47f08ff7ade.png";